import { Company } from "@/models/company";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { CompanyState } from "@/types/company";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";

const state: CompanyState = {
  single: new Company(),
  pagination: new Pagination(),
};

export const company: Module<CompanyState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
